import {SidebarCollapseIcon, SidebarExpandIcon} from '@primer/octicons-react'
import {Box, IconButton, SegmentedControl} from '@primer/react'

interface DiffProps {
  setTreeExpanded: (treeExpanded: boolean) => void
  treeExpanded: boolean
  treeEnabled: boolean
}
export function Diff({setTreeExpanded, treeExpanded, treeEnabled}: DiffProps) {
  return (
    <Box>
      <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <Box sx={{display: 'flex', alignItems: 'center'}}>
          {treeEnabled && (
            <IconButton
              variant="invisible"
              icon={treeExpanded ? SidebarExpandIcon : SidebarCollapseIcon}
              onClick={() => setTreeExpanded(!treeExpanded)}
              aria-label={treeExpanded ? 'Collapse tree' : 'Expand tree'}
              sx={{mr: 2}}
            />
          )}
          Change content
        </Box>
        <Box>
          <SegmentedControl sx={{px: 2}} aria-label="Whitespace toggle">
            <SegmentedControl.Button>Whitespace</SegmentedControl.Button>
            <SegmentedControl.Button>Ignore Whitespace</SegmentedControl.Button>
          </SegmentedControl>
          <SegmentedControl aria-label="Diff view options">
            <SegmentedControl.Button>Split</SegmentedControl.Button>
            <SegmentedControl.Button>Unified</SegmentedControl.Button>
          </SegmentedControl>
        </Box>
      </Box>
      Diff
    </Box>
  )
}

try{ Diff.displayName ||= 'Diff' } catch {}